export const COUNTRY_OPTIONS = [
    { "code": "AR", "name": "Argentina", "emoji": "🇦🇷" },
    { "code": "AU", "name": "Australia", "emoji": "🇦🇺" },
    { "code": "BD", "name": "Bangladesh", "emoji": "🇧🇩" },
    { "code": "BE", "name": "Belgium", "emoji": "🇧🇪" },
    { "code": "BR", "name": "Brazil", "emoji": "🇧🇷" },
    { "code": "CA", "name": "Canada", "emoji": "🇨🇦" },
    { "code": "CH", "name": "Switzerland", "emoji": "🇨🇭" },
    { "code": "CN", "name": "China Mainland", "emoji": "🇨🇳" },
    { "code": "DE", "name": "Germany", "emoji": "🇩🇪" },
    { "code": "DK", "name": "Denmark", "emoji": "🇩🇰" },
    { "code": "EG", "name": "Egypt", "emoji": "🇪🇬" },
    { "code": "ES", "name": "Spain", "emoji": "🇪🇸" },
    { "code": "FI", "name": "Finland", "emoji": "🇫🇮" },
    { "code": "FR", "name": "France", "emoji": "🇫🇷" },
    { "code": "GB", "name": "United Kingdom", "emoji": "🇬🇧" },
    { "code": "GR", "name": "Greece", "emoji": "🇬🇷" },
    { "code": "HK", "name": "Hong Kong", "emoji": "🇭🇰" },
    { "code": "ID", "name": "Indonesia", "emoji": "🇮🇩" },
    { "code": "IE", "name": "Ireland", "emoji": "🇮🇪" },
    { "code": "IL", "name": "Israel", "emoji": "🇮🇱" },
    { "code": "IN", "name": "India", "emoji": "🇮🇳" },
    { "code": "IT", "name": "Italy", "emoji": "🇮🇹" },
    { "code": "JP", "name": "Japan", "emoji": "🇯🇵" },
    { "code": "KR", "name": "South Korea", "emoji": "🇰🇷" },
    { "code": "LK", "name": "Sri Lanka", "emoji": "🇱🇰" },
    { "code": "MX", "name": "Mexico", "emoji": "🇲🇽" },
    { "code": "MY", "name": "Malaysia", "emoji": "🇲🇾" },
    { "code": "NL", "name": "Netherlands", "emoji": "🇳🇱" },
    { "code": "NO", "name": "Norway", "emoji": "🇳🇴" },
    { "code": "NZ", "name": "New Zealand", "emoji": "🇳🇿" },
    { "code": "PH", "name": "Philippines", "emoji": "🇵🇭" },
    { "code": "PK", "name": "Pakistan", "emoji": "🇵🇰" },
    { "code": "PL", "name": "Poland", "emoji": "🇵🇱" },
    { "code": "PT", "name": "Portugal", "emoji": "🇵🇹" },
    { "code": "RU", "name": "Russia", "emoji": "🇷🇺" },
    { "code": "SA", "name": "Saudi Arabia", "emoji": "🇸🇦" },
    { "code": "SE", "name": "Sweden", "emoji": "🇸🇪" },
    { "code": "SG", "name": "Singapore", "emoji": "🇸🇬" },
    { "code": "TH", "name": "Thailand", "emoji": "🇹🇭" },
    { "code": "TR", "name": "Turkey", "emoji": "🇹🇷" },
    { "code": "TW", "name": "Taiwan", "emoji": "🇹🇼" },
    { "code": "UA", "name": "Ukraine", "emoji": "🇺🇦" },
    { "code": "US", "name": "United States", "emoji": "🇺🇸" },
    { "code": "VN", "name": "Vietnam", "emoji": "🇻🇳" },
    { "code": "ZA", "name": "South Africa", "emoji": "🇿🇦" }
]
